const filtersData = {
  brands: ["mist", "harbour", "ucb", "hrx", "metro", "chucks"],
  color: ["black", "blue", "red", "green"]
};

const sortsData = ["low to high", "high to low",];

export { sortsData, filtersData };
